import { Button, IconEdit16 } from '@cian/ui-kit';
import * as React from 'react';

export interface IEditButtonProps {
  entityId: number;
  onClick(): void;
}

export class EditButton extends React.PureComponent<IEditButtonProps, {}> {
  public render() {
    const { onClick } = this.props;

    return (
      <Button
        title="Отредактировать заметку (видно только вам)"
        size="XS"
        theme="fill_secondary"
        onClick={onClick}
        beforeIcon={<IconEdit16 color="primary_100" />}
      />
    );
  }
}
